import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  const quickCategories = categories.filter(c => c.slug !== 'all').slice(0, 5);

  return (
    <footer className="bg-foreground-900 text-background-200">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6">
        <div className="py-12 md:py-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <span className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-vidicon-line text-background-50 text-lg"></i>
              </span>
              <span className="text-lg font-bold text-background-50 font-heading">
                福利视频大全
              </span>
            </div>
            <p className="text-sm text-foreground-300 leading-relaxed">
              精选海量福利视频资源，涵盖影视、综艺、音乐、体育、动漫、游戏、生活等多个领域，每日更新，免费在线观看。
            </p>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-background-50 mb-4 font-heading">快速分类</h3>
            <ul className="space-y-2.5">
              {quickCategories.map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-300 hover:text-primary-400 cursor-pointer transition-colors whitespace-nowrap"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-background-50 mb-4 font-heading">网站导航</h3>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-foreground-300 hover:text-primary-400 cursor-pointer transition-colors whitespace-nowrap">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/category/hot" className="text-sm text-foreground-300 hover:text-primary-400 cursor-pointer transition-colors whitespace-nowrap">
                  热门推荐
                </Link>
              </li>
              <li>
                <Link to="/category/all" className="text-sm text-foreground-300 hover:text-primary-400 cursor-pointer transition-colors whitespace-nowrap">
                  全部视频
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-300 hover:text-primary-400 cursor-pointer transition-colors whitespace-nowrap">
                  关于我们
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-background-50 mb-4 font-heading">联系我们</h3>
            <div className="space-y-2.5">
              <p className="text-sm text-foreground-300">
                <i className="ri-mail-line mr-2"></i>
                contact@fulivideo.com
              </p>
              <p className="text-sm text-foreground-300">
                <i className="ri-customer-service-2-line mr-2"></i>
                在线客服：工作日 9:00-18:00
              </p>
              <div className="flex items-center gap-3 pt-2">
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-foreground-800 text-background-200 hover:bg-primary-500 hover:text-background-50 cursor-pointer transition-colors" aria-label="微博" rel="nofollow">
                  <i className="ri-weibo-line text-lg"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-foreground-800 text-background-200 hover:bg-primary-500 hover:text-background-50 cursor-pointer transition-colors" aria-label="微信" rel="nofollow">
                  <i className="ri-wechat-2-line text-lg"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-foreground-800 text-background-200 hover:bg-primary-500 hover:text-background-50 cursor-pointer transition-colors" aria-label="哔哩哔哩" rel="nofollow">
                  <i className="ri-bilibili-line text-lg"></i>
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="py-6 border-t border-foreground-800 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-400">
            &copy; 2026 福利视频大全 fulivideo.com 版权所有
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-400 hover:text-primary-400 cursor-pointer transition-colors whitespace-nowrap" rel="nofollow">隐私政策</a>
            <a href="#" className="text-xs text-foreground-400 hover:text-primary-400 cursor-pointer transition-colors whitespace-nowrap" rel="nofollow">用户协议</a>
            <a href="#" className="text-xs text-foreground-400 hover:text-primary-400 cursor-pointer transition-colors whitespace-nowrap" rel="nofollow">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}